// translation key of the tab title, used when the host sends no title
export const DEFAULT_TEXT_LIBRARY_TITLE_KEY = 'editor-text-library-title';
